import { Kind } from "../../api/decimal/common-types/manageAssets.ts";
import { isBook, isCourseware } from "./assetHelpers.ts";
import { useIntl } from "react-intl";
import { SystemKind } from "../../api/decimal/common-types/kind.ts";

export function useAssetDescriptors(asset: { kind: Kind | SystemKind }) {
  const intl = useIntl();
  const descriptors: string[] = [];

  // I don't think we're using this yet, but I see some of these in my data
  // in the short term and want to call them out
  if (asset.kind.toLowerCase() === "subscription") {
    descriptors.push(intl.formatMessage({ defaultMessage: "Subscription" }));
  }

  if (asset.kind.toLowerCase() === "package") {
    descriptors.push(intl.formatMessage({ defaultMessage: "Package" }));
  }

  if (isBook(asset)) {
    descriptors.push(intl.formatMessage({ defaultMessage: "eBook" }));
  }

  if (isCourseware(asset)) {
    descriptors.push(intl.formatMessage({ defaultMessage: "Access Code" }));
  }

  if (asset.kind.toLowerCase() === "print book") {
    descriptors.push(intl.formatMessage({ defaultMessage: "Print" }));
  }

  return descriptors;
}
